<template>
    
    <v-row>
        <v-col cols="12">
            <TableA nombre="Asignación" :table="asignacion" :type="type" :headerss="header" :loadings="loading"/>
        </v-col>
    </v-row>
  
</template>
<script>

import Table from '../../../../component/helpers/tools/table'
import Single from '../../../../component/helpers/tools/single'
import TableA from '../../../../component/helpers/tools/tablesearchVehiculo'

export default {
    
    components:{
        Table,
        Single,
        TableA
    },

    data(){
        return {
            type:'asignación',
            header: [
                {
                    text: 'Nombre del conductor',
                    align: 'left',
                    sortable: false,
                    value: 'conductor',
                },
                { text: 'Cédula (conductor)', value: 'DNI' },
                { text: 'Vehículo', value: 'asignacion' },
                { text: 'Matricula (Vehículo)', value: 'matricula' },
                
                
            ]

        }
    },

    computed: {
        asignacion(){
            return this.$store.state.asignacion;
        },

        loading(){
            return this.$store.state.loading_dashboard
        },
        single(){
            return this.$store.state.select_table
        }
    },


}
</script>